import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { SphereDropzone } from "@components/common/sphere-dropzone/sphere-dropzone";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { isSingleFileUploadResponse } from "@custom-types/file-upload-type-guards";
import { UploadElementType } from "@custom-types/file-upload-types";
import { Dialog, Text } from "@flat-ui";
import { useAppDispatch } from "@store/store-helper";
import { updateCurrentUserProfile } from "@store/user/user-slice-thunk";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getUserInitials } from "@utils/user-utils";
import { useState } from "react";
/** Renders the update profile picture dialog and update the picture */
export function UpdateProfilePictureDialog({
  user,
  isDialogOpen,
  setIsDialogOpen
}) {
  const dispatch = useAppDispatch();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    trackEvent
  } = useTrackEvent();
  const [isLoading, setIsLoading] = useState(false);
  async function updateProfilePicture(thumbnailUrl) {
    try {
      trackEvent({
        name: UserProfile.updateProfile,
        props: {
          attribute: "profileImageUrl"
        }
      });
      await dispatch(updateCurrentUserProfile({
        thumbnailUrl
      })).unwrap();
    } catch (error) {
      handleErrorWithToast({
        id: `updateProfilePicture-${Date.now().toString()}`,
        title: "Could not change user data",
        error
      });
    } finally {
      setIsLoading(false);
    }
  }
  return <>
      {/* Update profile picture dialog */}
      <Dialog title="Profile picture" open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <Text variant="bodyM" sx={{
        marginBottom: SPACE_ELEMENTS_OF_MODAL,
        color: "text.primary"
      }}>
          Personalize your account and help others recognize you.
        </Text>

        <SphereDropzone avatar={<SphereAvatar src={user.thumbnailUrl} initials={getUserInitials(user)} size="x-large" shouldHideWhiteRim />} existingImageUrl={user.thumbnailUrl} isLoading={isLoading} setIsLoading={setIsLoading} context={{
        uploadElementType: UploadElementType.default,
        userId: user.identity
      }} onUploadComplete={uploadedResponse => {
        if (isSingleFileUploadResponse(uploadedResponse)) {
          void updateProfilePicture(uploadedResponse);
        }
      }} onDeleteButtonClick={() => updateProfilePicture(null)} deleteIconTooltipText="Remove profile picture" />
      </Dialog>
    </>;
}